import React, { useState, useEffect } from 'react';
import { useParams } from 'react-router-dom';
import Layout from '../Layout';
import { getProduct, getUserInfo } from '../../user/apiUser';
import { isAuthenticated } from '../../auth';
import { API } from '../../config';
import BuyButton from './BuyButton';
import Shipping from '../../user/add_product/Shipping';

const Checkout = () => {
    const [product, setProduct] = useState({});
    const { productId } = useParams();
    const [addressTo, setAddressTo] = useState({});
    const [addresses, setAddresses] = useState([]);
    const [addressChosen, setAddressChosen] = useState(false);

    const [userInfo, setUserInfo] = useState({})
    
    const handleShippingChange = event => {
        setAddressChosen(true);
        const value = event.target.value;
        setAddressTo(value);
    };
    
    const { user: {_id, email}, token } = isAuthenticated();

    useEffect(() => {
        getProduct(productId).then(data => {
            setProduct(data);
        });

        getUserInfo(_id).then(data => {
            setAddresses(data.shipping_addresses)
        });
    },[])

    const showError = () => (
        <div className="rounded-md bg-red-50 p-4" style={{display: error ? '' : 'none'}}>
            <div className="flex">
                <div className="ml-3">
                    <div className="mt-2 text-sm text-red-700 ">
                        <p className='pl-5 space-y-1'> {error} </p>
                    </div>
                </div>
            </div>
        </div>
    );

    const [error, setError] = useState('');

    return (
        <Layout>
            <div className="bg-gray-50">
                <div className="max-w-2xl mx-auto pt-16 pb-24 px-4 sm:px-6 lg:max-w-7xl lg:px-8">
                    <h2 className="sr-only">Checkout</h2>
                    <h3 className='text-xl'>Checkout</h3>
                    <form className="lg:grid lg:grid-cols-2 lg:gap-x-12 xl:gap-x-16">
                        <div className='mt-10'>
                            <h2 className='text-md'>Shipping Address</h2>
                            <Shipping 
                                addresses={addresses} 
                                handleShippingChange={handleShippingChange} 
                                setAddresses={setAddresses}
                            />

                            {JSON.stringify(addressTo)}
                       </div>

                        {/* Order summary */}
                        <div className="mt-10 lg:mt-0">
                            <h2 className="text-lg font-medium text-gray-900">Order summary</h2>

                            <div className="mt-4 bg-white border border-gray-200 rounded-lg shadow-sm">
                                <h3 className="sr-only">Items</h3>
                                <div className='divide-y divide-gray-200'>
                                    <div className='flex py-6 px-4 sm:px-6'>
                                <div className="flex-shrink-0">
                                    <img src={`${API}/static/product_photos/${product.primary_photo}`} alt='primary_photo' className="rounded-md w-32" />
                                </div>

                                <div className="ml-6 flex-1 flex flex-col">
                                    <div className="flex">
                                        <div className="min-w-0 flex-1">
                                            <h4 className="text-sm">
                                                <a className="font-medium text-gray-700 hover:text-gray-800">
                                                    {product.name}
                                                </a>
                                            </h4>
                                            <p className="mt-1 text-sm text-gray-500">{product.brand}</p>
                                            <p className="mt-1 text-sm text-gray-500">{product.size}</p>
                                        </div>

                                        <div className="ml-4 flex-shrink-0 flow-root">
                                        </div>
                                    </div>

                                    <div className="flex-1 pt-2 flex items-end justify-between">
                                        <p className="mt-1 text-sm font-medium text-gray-900">${product.price}</p>

                                    </div>
                                </div>
                                </div>
                                </div>
                                { /*
                                <dl className="border-t border-gray-200 py-6 px-4 space-y-6 sm:px-6">
                                    <div className="flex items-center justify-between">
                                        <dt className="text-sm">Subtotal</dt>
                                        <dd className="text-sm font-medium text-gray-900">$64.00</dd>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <dt className="text-sm">Shipping</dt>
                                        <dd className="text-sm font-medium text-gray-900">$5.00</dd>
                                    </div>
                                    <div className="flex items-center justify-between">
                                        <dt className="text-sm">Taxes</dt>
                                        <dd className="text-sm font-medium text-gray-900">$5.52</dd>
                                    </div>
                                    <div className="flex items-center justify-between border-t border-gray-200 pt-6">
                                        <dt className="text-base font-medium">Total</dt>
                                        <dd className="text-base font-medium text-gray-900">$75.52</dd>
                                    </div>
                                </dl>
                                */}

                                    {showError()}
                                <div className="border-t border-gray-200 py-6 px-4 sm:px-6">
                                    {/* Maybe put a transition here so that it fades or slides in */}
                                        <p className='text-sm text-gray-500'> Note: the address entered on paypal doesn't reflect where this item will be shipped</p>

                                    {addressChosen ?
                                        <BuyButton item={product} addrTo={addressTo} email={email}/>
                                        :
                                        <button
                                            type='button'
                                            className='w-full bg-indigo-600 border border-transparent rounded-md       shadow-sm py-3 px-4 text-base font-medium text-white'  
                                        >
                                            Waiting for shipping info...
                                        </button>
                                    }
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </Layout>
    )
};

export default Checkout;

